import React from 'react'
import {Modal} from 'common/modals'
import {Button, RemoveParticipatorButton} from 'common/buttons'
import {UserItem} from 'common/Items'
import {AddParticipatorModal} from 'common/modals'
import {LoadingPage} from 'common/Loading'

import {useQuery, useModal} from 'hooks'
import {queryAdventureParticipations} from 'graph'

/**
 * Author-facing participator management: lists the adventure's current participants
 * (each with a Remove action) and an "Add participators" button that opens the
 * candidate-picker modal (AddParticipatorModal) on top.
 */
export function EditParticipatorsModal(props: any)
{
	const {adventure} = props
	const {data, loading} = useQuery(queryAdventureParticipations, {
		variables: {id: adventure.id},
	})
	const openAdd = useModal(AddParticipatorModal, {adventure})

	const edges = data?.adventure?.participations?.edges ?? []

	return (
		<Modal {...props}>
			<div className="modal-body">
				<h2 className="mb-3">
					<small className="text-muted">Participants</small><br/>
					{adventure.title}
				</h2>

				{loading && edges.length === 0 && <LoadingPage />}

				{!loading && edges.length === 0 && (
					<p className="text-muted">No participators yet.</p>
				)}

				<div className="list-group list-group-flush">
					{edges.map((participation: any) => (
						<UserItem
							key={participation.id}
							user={participation.receiver}
							renderButton={() => (
								<div className="col-auto">
									<RemoveParticipatorButton
										participation={participation}
										adventure={adventure}
									/>
								</div>
							)}
						/>
					))}
				</div>
			</div>
			<div className="modal-footer">
				<Button variant="outline-primary" onClick={() => openAdd()}>
					Add participants
				</Button>
			</div>
		</Modal>
	)
}
